import UserService from "../services/UserService";

export default {
  namespaced: true,
  state: {
    user: null
  },

  getters: {
    getUser: state => state.user
  },

  actions: {
    async getUser({ commit, dispatch }) {
      try {
        let user = await UserService.initUser();
        commit("setUser", user);
      }
      catch (err) {
        // logoff
        if (err.response && err.response.status === 401) {
          dispatch("authorization/logout", null, { root: true });
          // HACK: injected in `main.js`
          if (this.$router) {
            this.$router.replace("/", () => {});
          }
        }

        throw err;
      }
    },

    clearUser({ commit }) {
      commit("setUser", "");
    }
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    }
  }
};
